import offerData from './offerData';

const root = {
	offerData
};

export default root;
